import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class KeepAlive extends Component {
  static propTypes = {
    url: PropTypes.string,
    location: PropTypes.shape().isRequired,
    history: PropTypes.shape({
      listen: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    url: null
  };

  static cacheBuster() {
    return `?timestamp=${ new Date().getTime() }`;
  }

  constructor(props) {
    super(props);

    this.state = {
      locationPathName: props.location.pathname,
      cacheBuster: KeepAlive.cacheBuster()
    };
  }

  componentDidMount() {
    const { history } = this.props;
    const { locationPathName } = this.state;

    this.unlisten = history.listen((location, action) => {
      if (location.pathname !== locationPathName || action === 'POP') {
        this.setState({
          locationPathName: location.pathname,
          cacheBuster: KeepAlive.cacheBuster()
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  render() {
    const { url } = this.props;
    const { cacheBuster } = this.state;

    return (
      <React.Fragment>
        { url && <img className="keepalive" height="0" alt="keep alive" src={ `${ url }${ cacheBuster }` } /> }
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig
    }
  } = state;

  return {
    url: onlineConfig && onlineConfig.keepAliveUrl
  };
}

export default withRouter(connect(
  mapStateToProps
)(KeepAlive));
